import { createContext } from "react";
import { Edition } from "../types";

interface EditionContextType {
  edition: Edition | null;
  setEdition: (edition: Edition) => void;
  currentEdition: Edition | null;
  isLoading: boolean;
}

export const EditionContext = createContext<EditionContextType | undefined>(undefined)
